import React from 'react';
import { useTranslation } from 'react-i18next';
import NotificationItem from '../NotificationItem';
import { logger } from '../../../../shared/utils/logger';
import './styles.css';

const NotificationsList = ({ notifications = [] }) => {
  const { t } = useTranslation('notifications');

  logger.debug('NotificationsList rendering:', {
    count: notifications.length,
    notifications: notifications.map(n => ({
      id: n.id,
      type: n.type,
      read: n.read,
      createdAt: n.createdAt
    }))
  });

  if (notifications.length === 0) {
    return (
      <div className="notifications-empty">
        {t('empty')}
      </div>
    );
  }

  return (
    <div className="notifications-list">
      <h2 className="notifications-title">{t('title')}</h2>
      {notifications.map((notification) => (
        <NotificationItem 
          key={notification.id} 
          notification={notification} 
        />
      ))}
    </div>
  );
};

export default NotificationsList; 